import { useEffect, useState } from "react";
import { MessageSquare, Search } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Card, SectionTitle } from "@/components/Kpi";
import { ChatSegnalazione } from "@/components/ChatSegnalazione";
import { useAuth } from "@/context/AuthContext";
import { eur } from "@/lib/format";

const quando = (iso) => iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" }) : "";

/** Storico delle chat sulle pratiche segnalate (a Gianluca o da Gianluca). */
export default function StoricoChat() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [cerca, setCerca] = useState("");
  const [aperta, setAperta] = useState(null);

  const carica = () => api.get(`/notifiche/chat?search=${encodeURIComponent(cerca)}`)
    .then((r) => setRows(r.data.rows)).catch((e) => toast.error(apiError(e)));
  useEffect(() => { const t = setTimeout(carica, 250); return () => clearTimeout(t); }, [cerca]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="storico-chat">
      <SectionTitle sub="Tutte le conversazioni sulle pratiche segnalate · clicca una riga per rileggere o continuare la chat"
        right={
          <label className="relative">
            <Search size={14} className="absolute left-2 top-1/2 -translate-y-1/2 text-slate-400" />
            <input value={cerca} onChange={(e) => setCerca(e.target.value)} placeholder="Cerca pratica, cliente, dealer, testo…" data-testid="storico-chat-cerca"
              className="pl-7 pr-3 py-2 text-sm rounded-md border border-slate-200 bg-white focus:outline-none focus:border-[#0018A8] w-80" />
          </label>
        }>
        Storico chat pratiche
      </SectionTitle>

      <Card className="p-0 overflow-hidden">
        <ul className="divide-y divide-slate-100" data-testid="storico-chat-lista">
          {rows.length === 0 && <li className="px-5 py-8 text-sm text-slate-400 text-center">Nessuna chat.</li>}
          {rows.map((c) => (
            <li key={c.id} data-testid={`storico-chat-${c.id}`}>
              <button type="button" onClick={() => setAperta((a) => (a === c.id ? null : c.id))}
                className="w-full text-left px-5 py-3 hover:bg-slate-50 transition-colors duration-150">
                <div className="flex items-center justify-between gap-3">
                  <span className="font-mono text-sm font-semibold text-slate-900">
                    <MessageSquare size={13} className="inline mr-2 text-[#0018A8]" />{c.external_id}
                  </span>
                  <span className="text-[11px] text-slate-400 whitespace-nowrap">{quando(c.creata_il)} · {c.n_messaggi} msg</span>
                </div>
                <div className="text-sm text-slate-700 mt-0.5 truncate">
                  {c.dealer_nome || "—"}{c.importo_finanziato ? ` · ${eur(c.importo_finanziato)}` : ""}{c.cliente ? ` · ${c.cliente}` : ""}
                </div>
                <div className="text-xs text-slate-500 mt-1 truncate">
                  aperta da <b>{c.creata_da_nome}</b>{c.ultimo ? <> · ultimo: <b>{c.ultimo.da_nome}</b>: {c.ultimo.testo}</> : null}
                </div>
              </button>
              {aperta === c.id && (
                <div className="px-5 pb-4">
                  <ChatSegnalazione chatId={c.id} me={user?.email} onClose={() => setAperta(null)} onChange={carica} />
                </div>
              )}
            </li>
          ))}
        </ul>
      </Card>
    </div>
  );
}
